<template>
  <v-card>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="guardar()"
    >
    <v-card-title>
      NUEVO FUNCIONARIO
      <v-spacer/>
      <v-btn icon @click="$emit('close')">
        X
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
              v-model="funcionario.ci"
              label="CI *"
              type="number"
              min="99999"
              max="99999999999"
              :rules="[v => !!v || 'CI es requerida',
                       v => v >= 99999 && v <= 9999999999 || 'Ventanilla debe estar entre 99999 y 9999999999']"
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
              v-model="funcionario.nombre"
              label="Nombre *"
              :rules="[v => !!v || 'Nombre es requerida',
                       v => v.toString().length >= 3 && v.toString().length <= 20 || 'Nombre debe tener entre 3 y 20 letras']"
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
              v-model="funcionario.apellido_paterno"
              label="Apellido parterno *"
              :rules="[v => !!v || 'Apellido paterno es requerida',
                       v => v.toString().length >= 3 && v.toString().length <= 20 || 'Apellido paterno debe tener entre 3 y 20 letras']"
          />
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
              v-model="funcionario.apellido_materno"
              label="Apellido materno"
              :rules="[v => v.toString().length >= 3 && v.toString().length <= 20 || 'Apellido materno debe tener entre 3 y 20 letras']"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
              v-model="funcionario.sexo"
              label="Sexo"
              :items="['M', 'F']"
              :rules="[v => !!v || 'Sexo paterno es requerida']"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-footer>
      <v-spacer/>
      <v-btn color="primary" type="submit">
        Guardar nuevo funcionario
      </v-btn>
    </v-footer>
    </v-form>
  </v-card>
</template>

<script lang="ts">

import {Component, Vue} from "vue-property-decorator";
import {cajeroStore} from "@/store/cajeroStore";
import {Funcionario} from "@/models/Funcionario";
import {CajeroService} from "@/services/CajeroService";

@Component({
  name: "FuncionarioForm"
})
export default class FuncionarioForm extends Vue {
  private cajeroStore = cajeroStore();
  private cajeroService = CajeroService.getInstance();
  valid = true;
  $refs!: {
    form: HTMLFormElement
  }

  get funcionario(): Funcionario {
    return this.cajeroStore.funcionario;
  }

  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }

    this.cajeroService.storeFuncionario(this.funcionario);
  }
}
</script>

<style scoped>

</style>